import React, { useEffect, useRef, useState } from "react";
import {
    Button,
    Table,
    Overlay,
    Popover,
    Col,
    Form,
    Row,
    Alert,
    OverlayTrigger,
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import { FixColumn } from "../../../../utils/dataTable";
import DatePicker from "react-datepicker";
import PriceSimulatorDetailAnalysis from "../../PriceSimulatorDetailAnalysis";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import darkNoteIcon from "../../../../Assets/Images/CRM/darkNotes.svg";
import WidgetNote from "../../WidgetNote";
import EventViewModal from "../../../CommonComponent/EventViewModal";
import ticket from "../../../../Assets/Images/Revenue-management/tableTicket.svg";
import CustomRangePicker from "../../../CommonComponent/CustomRangePIcker";

export const PricingSimulator = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const { snapshottitle, propertyCode: propertyCodeFromUrl, snapshotId } = useParams();

    const selectedData = useRef();

    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const propertyCode = para?.propertyCode || para?.PropertyCode || para?.propertycode || propertyCodeFromUrl || propertyDetailFromRTK?.propertycode || "";
    const propertyId = para?.propertyId || para?.PropertyId || para?.propertyid || propertyDetailFromRTK?.propertyid || 0;

    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
    });

    const widgetDetailRef = useRef();
    const startRangeDateRef = useRef();
    const endRangeDateRef = useRef();
    const [widgetModal, setWidgetModal] = useState(false);
    const [activePresetRange, setActivePresetRange] = useState(null);
    const [openDatePicker, setOpenDatePicker] = useState(false);
    const StartDate = para?.asOfDate ? new Date(para?.asOfDate) : new Date();
    const today = para?.asOfDate ? new Date(para?.asOfDate) : new Date();
    const futureDate = new Date(today);
    futureDate.setDate(today.getDate() + 30);
    const EndDate = futureDate;

    const [startRangeDate, setStartRangeDate] = useState(StartDate);
    const [endRangeDate, setEndRangeDate] = useState(EndDate);

    //#region --- Refrenced logic for startDate & endDate
    // const startDate = commonService.getDateInDBFormat(new Date());
    // const newDate = new Date();

    // newDate.setDate(newDate.getDate() + 7);
    // const endDate = commonService.getDateInDBFormat(newDate);
    const startOfWeek = new Date(para?.asOfDate);
    const day = startOfWeek.getDay(); // Sunday = 0, Monday = 1, ...
    const diff = day === 0 ? -6 : 1 - day; // adjust so Monday is start
    startOfWeek.setDate(startOfWeek.getDate() + diff);

    // Get end date = +14 days from startOfWeek
    const endOfWeekPlus14 = new Date(startOfWeek);
    endOfWeekPlus14.setDate(endOfWeekPlus14.getDate() + 14);

    // Format both using your service
    const startDate = commonService.getDateInDBFormat(startOfWeek);
    const endDate = commonService.getDateInDBFormat(endOfWeekPlus14);
    //#endregion --- Refrenced logic 

    const [DataDates, setDataDates] = useState({ startdate: StartDate, enddate: EndDate });


    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const [SimulatorRateGrid, setSimulatorRateGrid] = useState([]);
    const clickedDateForNote = useRef();
    const eventListRef = useRef();
    const eventListPropsRef = useRef();
    const selectedEventDateRef = useRef();
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const [noteDetail, setNoteDetail] = useState(null);
    const [showTicketModal, setShowTicketModal] = useState(false);
    const [DisplayLoading, setDisplayLoading] = useState(false);

    const getSimulatorRateGrid = async () => {
        setDisplayLoading(true);
        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.PRICING_SIMULATOR_RATE.PRICING_SIMULATOR_RATE_GRID,
                body: {
                    propertycode: para?.propertyCode,
                    asofdate: para?.asOfDate,
                    startdate: commonService.getDateInDBFormat(DataDates.startdate),
                    enddate: commonService.getDateInDBFormat(DataDates.enddate)
                },
            },
            false
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            setSimulatorRateGrid(response?.data?.data)
        }

        if (!response?.isValidate) {
            setSimulatorRateGrid([])
        }

        setDisplayLoading(false);
    };

    const getNoteByDataList = async () => {
        let noteByDataListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.WIDGET_NOTE.GET_BY_DATA_LIST,
                body: {
                    propertyid: propertyDetailFromRTK?.propertyid,
                    widgetid: para?.widgetId,
                    // widgetid: 0,
                    startdate: startRangeDateRef.current
                        ? commonService.getDateInDBFormat(startRangeDateRef.current)
                        : commonService.getDateInDBFormat(startDate),
                    enddate: endRangeDateRef.current
                        ? commonService.getDateInDBFormat(endRangeDateRef.current)
                        : commonService.getDateInDBFormat(endDate),
                },
            },
            false
        );

        let response = apiResponse(false, noteByDataListResponse);

        if (response?.isValidate) {
            setNoteDetail(response?.data?.data);
        }

        if (!response?.isValidate) {
            setNoteDetail(null);
        }
    };

    const getEventList = async () => {
        let eventList = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: parseInt(propertyDetailFromRTK?.propertyid),
                    startdate: null,
                    enddate: null,
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: ``,
                },
            },
            false
        );

        let eventListResponse = apiResponse(false, eventList);

        if (eventListResponse?.isValidate) {
            let eventListArr = [];

            eventListResponse?.data?.data?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: item?.startdate,
                        endDate: item?.enddate,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventListArr.push(singleEventObj);
                } catch (err) { }
            });
            eventListRef.current = eventListArr;
        }

        if (!eventListResponse?.isValidate) {
            eventListRef.current = [];
        }
    };

    let apiCalls = async () => {
        if (api === 0) return;
        setDisplayLoading(true)
        await getEventList();
        await getNoteByDataList();
        await getSimulatorRateGrid();
        setDisplayLoading(false)
    }

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.asOfDate) {
                apiCalls();
            }
        }
    }, [para, DataDates]);


    const handleDateChange = (event) => {
        const [start, end] = event;
        let startSelectedDate = "",
            endSelectedDate = "";
        if (start) {
            let date = new Date(start);
            let month =
                date.getMonth() + 1 > 9
                    ? date.getMonth() + 1
                    : `0${date.getMonth() + 1}`;
            let dateFormat =
                date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            startSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
            startRangeDateRef.current = startSelectedDate;
        }
        if (end) {
            let date = new Date(end);
            let month =
                date.getMonth() + 1 > 9
                    ? date.getMonth() + 1
                    : `0${date.getMonth() + 1}`;
            let dateFormat =
                date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            endSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
            endRangeDateRef.current = endSelectedDate;
        }

        setStartRangeDate(event[0]);
        setEndRangeDate(event[1]);
        setActivePresetRange(null);
    };

    const handleApplyRange = (start, end) => {
        setDataDates({ startdate: start, enddate: end })
    };

    function fnSetDataDates() {
        setDataDates({ startdate: startRangeDate, enddate: endRangeDate })
    }
    FixColumn(tblids.id1, [1, 2, 3]);

    const [DetailedAnalysis, setDetailedAnalysis] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });


    const closeSingleDate = () => {
        setDetailedAnalysis({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const closeTicketModal = () => {
        setShowTicketModal(false);
    };

    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    const htmlToText = (html) => {
        const tempElement = document.createElement("div");
        tempElement.innerHTML = html;
        const plainText = tempElement.innerText;
        return plainText;
    };

    const handleFilterBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setDetailedAnalysis({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    return (
        <>
            {propertyCode ? (
        <div className="widget-container snapshotrow" style={{ position: "relative", padding: "0 5px" }} rowtitle="What-If Pricing Simulator">
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("PricingSimulator", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.id1,
                                    "PricingSimulator",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("PricingSimulator", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.PickupAnalysis,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("PricingSimulator", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.id1}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.id1,
                                    `${para?.propertyCode}-PricingSimulator-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}

            <div className="ViewPropertySetupTable mainTableClass">
                {DisplayLoading ? (
                    <Loader />
                ) : (

                    <div className="stripped__table">
                        <div className="table-responsive tblDynamicPickupSticky">
                            <Table
                                id={tblids.id1}
                                className="table-with-spacing positionStaticTable dailySummaryTbl"
                            >
                                <thead className="tbl-header-sticky">
                                    <tr className="table-main-header-tr">
                                        <th className="width50  text-center border-right border-right-1">Note</th>
                                        <th id={commonService.generateGlobalClickTrackerID("PricingSimulator", "date", propertyCode)} className="width150  text-center" onClick={() => {
                                            setOpenDatePicker(true);
                                        }}>
                                            Date <br />
                                            <DatePicker id={commonService.generateGlobalClickTrackerID("PricingSimulator", "date", propertyCode)}
                                                minDate={new Date(para?.asOfDate)}
                                                portalId="datepicker-root"
                                                onChange={(event) => handleDateChange(event)}
                                                startDate={startRangeDate}
                                                endDate={endRangeDate}
                                                selectsRange
                                                monthsShown={2}
                                                open={openDatePicker}
                                                shouldCloseOnSelect={false}
                                                dateFormat="dd MMM"
                                                wrapperClassName="width110"
                                            >
                                                <div
                                                    className="w-100"
                                                    style={{ display: "inline-block" }}
                                                >
                                                    <CustomRangePicker id={commonService.generateGlobalClickTrackerID("PricingSimulator", "date", propertyCode)}
                                                        activePreset={activePresetRange}
                                                        setActivePreset={setActivePresetRange}
                                                        setOpenDatePicker={setOpenDatePicker}
                                                        onChange={(start, end, type) => {
                                                            setStartRangeDate(start);
                                                            setEndRangeDate(end);
                                                            handleApplyRange(start, end);
                                                        }}
                                                    />
                                                    <div className="content-inside-calendar">
                                                        <p>
                                                            {startRangeDate
                                                                ? commonService.getDateInFormat(
                                                                    startRangeDate
                                                                )
                                                                : ""}
                                                            {startRangeDate && endRangeDate
                                                                ? " - "
                                                                : ""}
                                                            {endRangeDate
                                                                ? commonService.getDateInFormat(
                                                                    endRangeDate
                                                                )
                                                                : ""}
                                                        </p>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <button id={commonService.generateGlobalClickTrackerID("PricingSimulator", "date", propertyCode)}
                                                                className="secondary-btn"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setStartRangeDate(StartDate);
                                                                    setEndRangeDate(EndDate);

                                                                    setDataDates({ startdate: StartDate, enddate: EndDate })

                                                                    setOpenDatePicker(false);
                                                                    setActivePresetRange(null);
                                                                }}
                                                            >
                                                                Cancel
                                                            </button>
                                                            <button id={commonService.generateGlobalClickTrackerID("PricingSimulator", "date", propertyCode)}
                                                                disabled={
                                                                    startRangeDate && endRangeDate
                                                                        ? false
                                                                        : true
                                                                }
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    fnSetDataDates();
                                                                    setOpenDatePicker(false);
                                                                    setActivePresetRange(null);
                                                                }}
                                                                className="primary-btn"
                                                            >
                                                                Apply
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </DatePicker>
                                            {startRangeDate && endRangeDate && (
                                                <span
                                                    style={{ display: "none" }}
                                                >{`${commonService.getDateInFormat(
                                                    startRangeDate
                                                )} - ${commonService.getDateInFormat(
                                                    endRangeDate
                                                )}`}</span>
                                            )}
                                        </th>
                                        <th className="width100  text-center border-right border-right-1">Verdict</th>
                                        <th className="width80  text-center">OTB Rooms</th>
                                        <th className="width90  text-center">OTB Occ%</th>

                                        <th className="width90  text-center">Forecasted Occ%</th>
                                        <th className="width100  text-center">ADR</th>

                                        <th className="width100  text-center">BAR (Current)</th>

                                        {/* <th className="width100  text-center border-right">CompSet AVG</th>
                                        <th className="width100  text-center">CompSet Min</th>
                                        <th className="width100  text-center">CompSet Max</th> */}

                                        <th className="width100  text-center border-right">Predicted Rate (RM)</th>
                                        <th className="width90  text-center border-right">Rate Change %</th>
                                        <th className="width90  text-center border-right">Predicted Occ Impact</th>
                                        <th className="width90  text-center border-right">Proposed Occ %</th>

                                        <th className="width100  text-center border-right">Current RevPAR</th>
                                        <th className="width100  text-center border-right">Proposed RevPAR</th>
                                        <th className="width100  text-center border-right">Revenue Impact</th>

                                        <th className="width100  text-center border-right">CompSet AVG</th>
                                        <th className="width100  text-center">CompSet Min</th>
                                        <th className="width100  text-center">CompSet Max</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        SimulatorRateGrid &&
                                        SimulatorRateGrid.map((item) => {
                                            let checkEvent = eventListRef.current?.filter((x) => {
                                                let checkingDate = moment(item.dates);
                                                let startingDate = moment(x?.startDate);
                                                let endingDate = moment(x?.endDate);
                                                if (
                                                    checkingDate.isSameOrAfter(startingDate) &&
                                                    checkingDate.isSameOrBefore(endingDate)
                                                ) {
                                                    return x;
                                                }
                                            });

                                            let checkNoteExists = []
                                            if (noteDetail?.notedata) {
                                                checkNoteExists = noteDetail?.notedata?.filter(
                                                    (x) =>
                                                        moment(x?.datadate).format("YYYY-MM-DD") ===
                                                        moment(item.dates).format("YYYY-MM-DD")
                                                );
                                            }

                                            return <tr key={item.dates} className={`${item.dayofweek && (item.dayofweek.toUpperCase() === "FRI" || item.dayofweek.toUpperCase() === "SAT") ? "backgroundTr " : ""}`}>
                                                <td className={"text-center border-right border-right-1"}>
                                                    <div>
                                                        {checkNoteExists?.length > 0 ? (
                                                            <img id={commonService.generateGlobalClickTrackerID("PricingSimulator", "note", item)}
                                                                className="cursorPointer"
                                                                src={darkNoteIcon}
                                                                onClick={() => {
                                                                    clickedDateForNote.current = commonService.getDateInFormat(item.dates);
                                                                    setShowNoteSidebar(true);
                                                                }}
                                                                alt="note"
                                                            />
                                                        ) : (
                                                            <img id={commonService.generateGlobalClickTrackerID("PricingSimulator", "note", item)}
                                                                className="cursorPointer"
                                                                src={NoteIcon}
                                                                onClick={() => {
                                                                    clickedDateForNote.current = commonService.getDateInFormat(item.dates);
                                                                    setShowNoteSidebar(true);
                                                                }}
                                                                alt="note"
                                                            />
                                                        )}
                                                        <div style={{ display: "none" }}>
                                                            {checkNoteExists?.map((item, index) => {
                                                                return (
                                                                    <>
                                                                        <span>{`${item?.displayname
                                                                            } - ${htmlToText(
                                                                                item?.widgetnotes
                                                                            )}`}</span>{" "}
                                                                        <br />
                                                                    </>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex gap-1">
                                                        <div className="d-flex gap-4">
                                                            {commonService.getDateInFormat(
                                                                // startDateArrayRef.current[index]
                                                                item.dates
                                                            )}{" "}
                                                            {moment(
                                                                // new Date(startDateArrayRef.current[index]),
                                                                new Date(item.dates),
                                                                "l"
                                                            ).format("ddd")}
                                                            <div className="d-flex justify-content-between align-items-center gap-2 ticketAlarmReload">
                                                                {checkEvent?.length > 0 && (
                                                                    <img id={commonService.generateGlobalClickTrackerID("PricingSimulator", "ticket", item)}
                                                                        style={{ height: "11px", width: "11px" }}
                                                                        className="iconcolor"
                                                                        src={ticket}
                                                                        alt="ticket"
                                                                        onClick={() => {
                                                                            selectedEventDateRef.current = item.dates;
                                                                            eventListPropsRef.current = checkEvent;
                                                                            setShowTicketModal(true);
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                {/* <td>{commonService.getDateInFormat(item.dates)} {item.dayofweek}</td> */}
                                                <td className={`border-right text-center border-right-1 color ${item.verdict ? item.verdict.replace(" ", "").toLowerCase() : ""}`}>{item.verdict ? item.verdict.toUpperCase() : ""}</td>
                                                <td className={"text-center"}>{item.otb_rooms}</td>
                                                <td className={"text-center"}>{item.otb_occ_perc} %</td>

                                                <td className={"text-center"}>{item.forecasted_occ_perc} %</td>
                                                <td className={"text-end"}>{commonService.formateAmount(item.adr ? item.adr : 0)}</td>
                                                <td className={"text-end "}  title={item.rate_status_code !== "200" && item.bar_current !== "" && parseFloat(item.bar_current) === 0 ? item.rate_status_desc : ""}>
                                                    {commonService.formateAmount(item.bar_current ? item.bar_current : 0)}
                                                </td>

                                                <td className={"text-end border-right text-primary"} style={{ cursor: "pointer" }} >

                                                    <span id={commonService.generateGlobalClickTrackerID("PricingSimulator", "predicted-rate-rm", item)} onClick={(e) => { selectedData.current = item; handleFilterBtnClick(e); }}>
                                                        {commonService.formateAmount(item.optimal_bar ? item.optimal_bar : 0)}
                                                    </span>
                                                </td>
                                                <td className={"text-center border-right"}>{item.rate_change_perc} %</td>
                                                <td className={"text-center border-right"}>{item.predicted_occ_impact}</td>
                                                <td className={"text-center border-right"}>{item.proposed_occ_perc} %</td>

                                                <td className={"text-end border-right"}>{commonService.formateAmount(item.current_revpar ? item.current_revpar : 0)}</td>
                                                <td className={"text-end border-right"}>{commonService.formateAmount(item.proposed_revpar ? item.proposed_revpar : 0)}</td>
                                                <td className={"text-end border-right"}>{commonService.formateAmount(item.revenue_impact ? item.revenue_impact : 0)}</td>

                                                <td className={"text-end border-right"}>{commonService.formateAmount(item.compset_avg ? item.compset_avg : 0)}</td>
                                                <td className={"text-end"}>{commonService.formateAmount(item.compset_min ? item.compset_min : 0)}</td>
                                                <td className={"text-end"}>{commonService.formateAmount(item.compset_max ? item.compset_max : 0)}</td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </div>
                )}
            </div>
            {api !== 0 && (
                <Comments widgetDetails={para} editorId={"PricingSimulator"} />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            {DetailedAnalysis.IsDisplay && (
                <PriceSimulatorDetailAnalysis
                    show={DetailedAnalysis.IsDisplay}
                    closeModal={closeSingleDate}
                    data={{ asOfDate: para?.asOfDate, propertyCode: propertyCode, selectedItem: selectedData.current }}
                />
            )}


            {showTicketModal && (
                <EventViewModal
                    showModal={showTicketModal}
                    closeModal={closeTicketModal}
                    eventDetails={eventListPropsRef.current}
                    selectedDate={selectedEventDateRef.current}
                    getEventList={getEventList}
                />
            )}
            {showNoteSidebar && (
                <WidgetNote
                    show={showNoteSidebar}
                    handleClose={closeNoteSideBar}
                    widgetId={para?.widgetId}
                    // widgetId={0}
                    propertyId={propertyId}
                    rowTitle={para?.rowTitle}
                    dateForNote={clickedDateForNote.current}
                />
            )}
        </div>
            ) : (
                <div className="d-flex justify-content-center p-5">
                    <h5>Please Select Property</h5>
                </div>
            )}
        </>
    );
};

export default PricingSimulator;
